<style scoped>
.input-setting-block .text-info-after-input-block p {
    margin: 28px 5px;
}
</style>

<template>
<div class="col-12 row input-setting-block">
  <div class="offset-1 col-1 elips"></div>
  <div class="col-2 item-name">
    Использовать режим "антизакисания"
  </div>
  <div class="col-2 scouring-checkbox-block">
    <input  id="scouring-checbox"
            v-model="scouring_status" @change="saveScouring()" type="checkbox" autocomplete="off" :class="{disabled: disabled_checbox}">
    <label for="scouring-checbox">.</label>
  </div>
  <div class="col-5 text-info-after-input-block">
    <p>Кран будет менять свое состояние на несколько секунд для предотвращения его блокировки, в 3:00 каждый понедельник</p>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import config from '@/config.js'

export default {
  created() {
    get_faucet_scouring_status(this)
    this.setinterval_get_faucet_scouring = setInterval(() => {
        get_faucet_scouring_status(this)
    }, 15000);
  },
  data() {
    return {
      scouring_status: null,
      disabled_checbox: true,
      setinterval_get_faucet_scouring: null
    }
  },
  watch: {
    // scouring_status: function (this_scouring_status, old_scouring_status) {
    //   if (old_scouring_status != null && this_scouring_status != old_scouring_status) {
    //     saveScouring(this_scouring_status, this)
    //   }
    // }
  },
  methods: {
      saveScouring: function () {
          saveScouring(this.scouring_status, this)
      }
  },
  props: ['id_faucet'],
  destroyed() {
      clearInterval(this.setinterval_get_faucet_scouring)
  },
}


function get_faucet_scouring_status(vue_obj) {
  if (!!localStorage.token) {
    var post_data = new FormData()
    post_data.set('token', localStorage.token)
    post_data.set('id_faucet', vue_obj.id_faucet)

    axios({
        method: 'POST',
        url: config.API_HOST + '/faucets/get_scouring_faucet',
        data: post_data
      })
      .then(function (response) {
        if (typeof response.data.scouring !=='undefined') {
          vue_obj.scouring_status = response.data.scouring
          vue_obj.disabled_checbox = false
        }
        
      })
      .catch(function (error) {
        console.log(error.response.data)
      })
  }
}

function saveScouring(new_scouring_status, vue_obj) {
  var post_data = new FormData()
  post_data.set('token', localStorage.token)
  post_data.set('id_faucet', vue_obj.id_faucet)
  post_data.set('scouring', new_scouring_status)

  axios({
      method: 'POST',
      url: config.API_HOST + '/faucets/change_scouring_faucet',
      data: post_data
    })
    .then(function (request) {
      console.log(request)
    })
    .catch(function (error) {
      if (!!error.response.data.exception) {
        vue_obj.faucet_name_msg = error.response.data.exception
      }
    })
}
</script>

<style scoped>
.scouring-checkbox-block {
  padding: 30px 0 0 75px;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/scouring.vue